<template>
  <div>
    <el-button
      v-if="!!type"
      type="warning"
      @click="handleDialog"
      circle
      icon="el-icon-plus"
    ></el-button>
    <el-button v-else type="primary" @click="handleDialog" size="mini">設定</el-button>
    <el-dialog
      top="2%"
      width="80%"
      :visible.sync="dialogFormVisible"
      title="活動推播設定"
      @closed="onDialogClosed"
    >
      <div class="notice">
        <el-form
          :model="pushNotification"
          :rules="pushNotificationRules"
          size="small"
          class="notice-form"
          label-position="left"
          ref="formRef"
        >
          <el-form-item label="推播對象" prop="pushType">
            <el-radio-group
              v-model="pushNotification.pushType"
              style="display: flex"
              @change="handleChangePushType"
            >
              <el-radio-button label="all">所有旅行團</el-radio-button>
              <el-radio-button label="special">指定旅行團</el-radio-button>
            </el-radio-group>
            <div>
              <el-select
                class="notice-form__select"
                v-model="pushNotification.travelIDs"
                multiple
                placeholder="請選擇旅行團"
                :disabled="pushNotification.pushType === 'all'"
              >
                <el-option
                  v-for="item in groupOptions"
                  :key="item.id"
                  :label="item.travelName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="推播標題" prop="subject">
            <el-input
              v-model="pushNotification.subject"
              name="subject"
              show-word-limit
              maxlength="10"
              placeholder="請輸入推播標題（10字內）"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="推播內文" prop="content">
            <el-input
              v-model="pushNotification.content"
              name="content"
              type="textarea"
              show-word-limit
              resize="none"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="請輸入推播內文（30字內）"
              maxlength="30"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="自訂連結" prop="link" v-if="!!type">
            <el-input v-model="pushNotification.link" name="link" placeholder="請輸入自訂連結">
            </el-input>
          </el-form-item>
          <div class="notice-footer">
            <el-button type="warning" @click="handleSubmit" style="color: #4b4b4b">
              發 送
            </el-button>
            <el-button @click="dialogFormVisible = false"> 取 消 </el-button>
          </div>
        </el-form>
        <div class="notice-preview" v-if="!type">
          <span class="notice-preview__title">預覽</span>
          <div class="coupon-detail">
            <div class="coupon-banner">
              <img
                :src="data.fileInfo[0].files[0].url"
                :alt="data.fileInfo[0].files[0].fileName"
                style="width: 100%; height: 100%"
              />
            </div>
            <div style="width: 100%; height: 1px; background: #e5e5e5"></div>
            <div class="coupon-main" ref="couponMain">
              <div class="coupon-header">
                <div>
                  <h1 class="coupon-title">{{ data.couponName }}</h1>
                </div>
                <div class="coupon-action">
                  <div class="icon-container">
                    <svg
                      fill="#000000"
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 296.528 296.528"
                      xml:space="preserve"
                    >
                      <g>
                        <path
                          d="M295.838,115.347l0.003-0.001l-0.092-0.76c-0.001-0.013-0.002-0.023-0.004-0.036c-0.001-0.011-0.002-0.021-0.004-0.032
                                        l-0.344-2.858c-0.069-0.574-0.148-1.228-0.238-1.974l-0.072-0.594l-0.147,0.018c-3.617-20.571-13.553-40.093-28.942-56.762
                                        c-15.317-16.589-35.217-29.687-57.548-37.878c-19.133-7.018-39.434-10.577-60.337-10.577c-28.22,0-55.627,6.637-79.257,19.193
                                        C23.289,47.297-3.585,91.799,0.387,136.461c2.056,23.111,11.11,45.11,26.184,63.621c14.188,17.423,33.381,31.483,55.503,40.66
                                        c13.602,5.642,27.051,8.301,41.291,11.116l1.667,0.33c3.921,0.776,4.975,1.842,5.247,2.264c0.503,0.784,0.24,2.329,0.038,3.18
                                        c-0.186,0.785-0.378,1.568-0.57,2.352c-1.529,6.235-3.11,12.683-1.868,19.792c1.428,8.172,6.531,12.859,14.001,12.86
                                        c0.001,0,0.001,0,0.002,0c8.035,0,17.18-5.39,23.231-8.956l0.808-0.475c14.436-8.478,28.036-18.041,38.271-25.425
                                        c22.397-16.159,47.783-34.475,66.815-58.17C290.172,175.745,299.2,145.078,295.838,115.347z M92.343,160.561H66.761
                                        c-3.866,0-7-3.134-7-7V99.865c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7v46.696h18.581c3.866,0,7,3.134,7,7
                                        C99.343,157.427,96.209,160.561,92.343,160.561z M119.03,153.371c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V99.675
                                        c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7V153.371z M182.304,153.371c0,3.033-1.953,5.721-4.838,6.658
                                        c-0.712,0.231-1.441,0.343-2.161,0.343c-2.199,0-4.323-1.039-5.666-2.888l-25.207-34.717v30.605c0,3.866-3.134,7-7,7
                                        c-3.866,0-7-3.134-7-7v-52.16c0-3.033,1.953-5.721,4.838-6.658c2.886-0.936,6.045,0.09,7.827,2.545l25.207,34.717V99.675
                                        c0-3.866,3.134-7,7-7c3.866,0,7,3.134,7,7V153.371z M233.311,159.269h-34.645c-3.866,0-7-3.134-7-7v-26.847V98.573
                                        c0-3.866,3.134-7,7-7h33.57c3.866,0,7,3.134,7,7s-3.134,7-7,7h-26.57v12.849h21.562c3.866,0,7,3.134,7,7c0,3.866-3.134,7-7,7
                                        h-21.562v12.847h27.645c3.866,0,7,3.134,7,7S237.177,159.269,233.311,159.269z"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="icon-container">
                    <svg
                      class="coupon-icon coupon-icon__share"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 16.58C17.24 16.58 16.56 16.88 16.04 17.35L8.91 13.2C8.96 12.97 9 12.74 9 12.5C9 12.26 8.96 12.03 8.91 11.8L15.96 7.69C16.5 8.19 17.21 8.5 18 8.5C18.7956 8.5 19.5587 8.18393 20.1213 7.62132C20.6839 7.05871 21 6.29565 21 5.5C21 4.70435 20.6839 3.94129 20.1213 3.37868C19.5587 2.81607 18.7956 2.5 18 2.5C17.2044 2.5 16.4413 2.81607 15.8787 3.37868C15.3161 3.94129 15 4.70435 15 5.5C15 5.74 15.04 5.97 15.09 6.2L8.04 10.31C7.5 9.81 6.79 9.5 6 9.5C5.20435 9.5 4.44129 9.81607 3.87868 10.3787C3.31607 10.9413 3 11.7044 3 12.5C3 13.2956 3.31607 14.0587 3.87868 14.6213C4.44129 15.1839 5.20435 15.5 6 15.5C6.79 15.5 7.5 15.19 8.04 14.69L15.16 18.84C15.11 19.05 15.08 19.27 15.08 19.5C15.08 21.11 16.39 22.41 18 22.41C19.61 22.41 20.92 21.11 20.92 19.5C20.92 18.7256 20.6124 17.9829 20.0648 17.4352C19.5171 16.8876 18.7744 16.58 18 16.58Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div class="icon-container">
                    <svg
                      class="coupon-icon coupon-icon__web"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.9 17.89C17.64 17.09 16.89 16.5 16 16.5H15V13.5C15 13.2348 14.8946 12.9804 14.7071 12.7929C14.5196 12.6054 14.2652 12.5 14 12.5H8V10.5H10C10.2652 10.5 10.5196 10.3946 10.7071 10.2071C10.8946 10.0196 11 9.76522 11 9.5V7.5H13C13.5304 7.5 14.0391 7.28929 14.4142 6.91421C14.7893 6.53914 15 6.03043 15 5.5V5.09C17.93 6.27 20 9.14 20 12.5C20 14.58 19.2 16.47 17.9 17.89ZM11 20.43C7.05 19.94 4 16.58 4 12.5C4 11.88 4.08 11.28 4.21 10.71L9 15.5V16.5C9 17.0304 9.21071 17.5391 9.58579 17.9142C9.96086 18.2893 10.4696 18.5 11 18.5M12 2.5C10.6868 2.5 9.38642 2.75866 8.17317 3.2612C6.95991 3.76375 5.85752 4.50035 4.92893 5.42893C3.05357 7.3043 2 9.84784 2 12.5C2 15.1522 3.05357 17.6957 4.92893 19.5711C5.85752 20.4997 6.95991 21.2362 8.17317 21.7388C9.38642 22.2413 10.6868 22.5 12 22.5C14.6522 22.5 17.1957 21.4464 19.0711 19.5711C20.9464 17.6957 22 15.1522 22 12.5C22 11.1868 21.7413 9.88642 21.2388 8.67317C20.7362 7.45991 19.9997 6.35752 19.0711 5.42893C18.1425 4.50035 17.0401 3.76375 15.8268 3.2612C14.6136 2.75866 13.3132 2.5 12 2.5Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div id="couponDescs"></div>
              <div class="coupon-content" style="max-width: 100%">
                <div class="content-header">
                  <h3>優惠內容</h3>
                  <h3 class="content-header" v-show="!!agencyTel">
                    <svg
                      class="coupon-icon coupon-icon__phone"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9C16.3 14.9 16.2 14.9 16.1 14.9C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5ZM5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5ZM19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19Z"
                        fill="black"
                      />
                      <path
                        d="M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5Z"
                        fill="none"
                      />
                      <path
                        d="M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19Z"
                        fill="none"
                      />
                    </svg>
                    <span class="content-header__phone">{{ agencyTel }}</span>
                  </h3>
                </div>
                <p>{{ data.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTravelNoFilter } from '@/api/travel'
import { notificationTravels } from '@/api/notification'
import { Loading, Message } from 'element-ui'

export default {
  name: 'NotificationSetting',
  props: {
    data: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pushNotification: {
        pushType: 'all',
        travelIDs: [],
        subject: this.$store.getters.userInfo.agencyShortName || '',
        content: '',
        link: '',
      },
      pushNotificationRules: {
        subject: [
          {
            required: true,
            message: '請輸入推播標題',
            trigger: 'blur',
          },
          { validator: this.validateSubjectLength, trigger: 'blur' },
        ],
        content: [
          {
            required: true,
            message: '請輸入推播內文',
            trigger: 'blur',
          },
          { validator: this.validateContentLength, trigger: 'blur' },
        ],
        pushType: [
          {
            required: true,
            message: '請選擇團體',
            trigger: 'blur',
          },
        ],
      },
      groupOptions: [],
      dialogFormVisible: false,
      agencyTel: this.$store.getters.userInfo.agencyTel,
    }
  },
  methods: {
    // 取得旅行團列表
    async handleGetTravelGroups() {
      const agencyCode = !!this.type ? null : this.data.agencyTravelInfo.agencyCode
      const loadingInstance = Loading.service({ fullscreen: true })
      await getTravelNoFilter(agencyCode)
        .then(res => {
          this.groupOptions = res.data
          if (this.pushNotification.pushType === 'all') {
            const allTravelID = this.groupOptions.map(item => item.id)
            this.pushNotification.travelIDs = allTravelID
          }
          this.dialogFormVisible = true
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          loadingInstance.close()
        })
    },

    // 開啟發送推播彈窗
    async handleDialog() {
      this.handleGetTravelGroups()
      this.pushNotification = {
        pushType: 'all',
        travelIDs: [],
        subject: this.$store.getters.userInfo.agencyShortName || '',
        content: '',
      }
    },
    onDialogClosed() {
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
    },
    // 標題字數驗證
    validateSubjectLength(rule, value, callback) {
      if (value && value.length > 10) {
        callback(new Error('推播標題不能超過10個字'))
      } else {
        callback()
      }
    },

    // 內容字數驗證
    validateContentLength(rule, value, callback) {
      if (value && value.length > 30) {
        callback(new Error('推播標題不能超過30個字'))
      } else {
        callback()
      }
    },

    // 變更推播對象
    handleChangePushType(type) {
      if (type === 'all') {
        const allTravelID = this.groupOptions.map(item => item.id)
        this.pushNotification.travelIDs = allTravelID
      } else {
        this.pushNotification.travelIDs = []
      }
    },

    // 發送推播
    async handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        if (
          !confirm(
            '此優惠活動資訊將從APP發送推播通知給所選擇旅遊團之旅客，是否確認要發送推播通知？'
          )
        )
          return
        const agencyCode = this.$store.getters.userInfo.agencyCode
        const isProdMode = process.env.NODE_ENV === 'production'
        const devUrl = 'https://webviewtest.itainctw.com'
        const prodUrl = 'https://webview.itainctw.com'
        const defaultUrl = isProdMode ? prodUrl : devUrl
        const { subject, content, travelIDs, link } = this.pushNotification
        const params = {
          subject: subject,
          content: content,
          travelIDs: travelIDs,
          innserDataType: !!this.type ? 0 : 1, // 旅行社發送帶1,智遊旅程發送帶0
          data: {
            fcmType: 15, // 推播類別: 此api固定帶15
            data: {
              url: !!this.type
                ? link
                : `${defaultUrl}/customPage/coupon.html?id=${this.data.id}&type=notification&agencyCode=${agencyCode}`,
            },
          },
        }
        console.log(params)
        const loadingInstance = Loading.service({ fullscreen: true })
        await notificationTravels(params)
          .then(res => {
            console.log(res)
            Message({
              message: '設定完成，推播通知已發送成功',
              type: 'success',
            })
            this.dialogFormVisible = false
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            loadingInstance.close()
          })
      })
    },
  },
}
</script>
<style scoped>
.notice {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-around;
  width: 100%;
}

.notice-form {
  flex-grow: 1;
}

.notice-form__select {
  width: 100%;
  margin-top: 12px;
}

.notice-footer {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
}

.notice-preview__title {
  background: #eee;
  display: block;
  padding: 4px 0;
  letter-spacing: 0.1em;
}

.coupon-detail {
  max-width: 320px;
  max-height: 500px;
  overflow-y: auto;
  line-height: 1.5rem;
  letter-spacing: 0.1em;
  border: 1px solid #e5e5e5;
}

.coupon-detail .coupon-banner {
  padding: 8px 0;
  width: 100%;
  aspect-ratio: 4/3;
  overflow: hidden;
  /* border-bottom: 1px solid #e5e5e5; */
}

.coupon-detail .coupon-banner img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.coupon-detail .coupon-main {
  padding: 20px 16px;
}

.coupon-detail .coupon-main .coupon-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0 8px;
}

.coupon-detail .coupon-main .coupon-header .coupon-title {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}

.coupon-detail .coupon-main #couponDescs .coupon-desc {
  margin: 0;
  margin-top: 6px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.coupon-detail .coupon-main .coupon-header .coupon-action {
  display: flex;
  gap: 0 16px;
}

.coupon-detail .coupon-main .coupon-header .icon-container {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.coupon-detail .coupon-main .coupon-header .coupon-icon {
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.coupon-detail .coupon-main .coupon-content .content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0 8px;
}

.coupon-detail .coupon-main .coupon-content h3.content-header {
  font-size: 14px;
  gap: 0 4px;
  cursor: pointer;
}

.coupon-detail .coupon-main .coupon-content h3.content-header .content-header__phone {
  font-size: 12px;
}

.coupon-detail .coupon-main .coupon-content h3.content-header .coupon-icon__phone {
  width: 12px;
  height: 12px;
}

.coupon-detail .coupon-main .coupon-content h3 {
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  padding-top: 20px;
  padding-bottom: 8px;
  letter-spacing: 0.1em;
}

.coupon-detail .coupon-main .coupon-content p {
  margin: 0;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.1em;
  word-break: break-all;
  white-space: pre-wrap;
}
</style>
